var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "w-card",
    { attrs: { "max-width": "500" } },
    [
      _c(
        "w-card-title",
        [
          _vm._v(" " + _vm._s(_vm.$ct("peppol-send"))),
          _c("w-spacer"),
          !_vm.hasModule
            ? _c(
                "w-link",
                {
                  attrs: { white: "" },
                  on: {
                    click: function ($event) {
                      return _vm.close()
                    },
                  },
                },
                [_c("w-fa", { attrs: { icon: "times" } })],
                1
              )
            : _vm._e(),
        ],
        1
      ),
      _vm.hasModule
        ? [
            _vm.sending
              ? _c("w-progress-linear", { staticClass: "progress" })
              : _vm._e(),
            _c(
              "w-card-content",
              [
                !_vm.isDossierFilledIn
                  ? _c(
                      "w-row",
                      [
                        _c(
                          "w-col",
                          { attrs: { xs: "12" } },
                          [
                            _c("app-error-message-box", [
                              _c("div", [
                                _vm._v(
                                  _vm._s(
                                    _vm.$ct("peppol-dossier-not-filled-in")
                                  )
                                ),
                              ]),
                              _c("div", [
                                _c(
                                  "a",
                                  {
                                    staticClass: "link",
                                    on: {
                                      click: function ($event) {
                                        $event.preventDefault()
                                        return _vm.editDossierSettings()
                                      },
                                    },
                                  },
                                  [
                                    _vm._v(
                                      _vm._s(
                                        _vm.$ct(
                                          "click-here-to-complete-dossier-setup"
                                        )
                                      )
                                    ),
                                  ]
                                ),
                              ]),
                            ]),
                          ],
                          1
                        ),
                      ],
                      1
                    )
                  : _vm._e(),
                !_vm.isDefaultBankFilledIn
                  ? _c(
                      "w-row",
                      [
                        _c(
                          "w-col",
                          { attrs: { xs: "12" } },
                          [
                            _c("app-error-message-box", [
                              _c("div", [
                                _vm._v(
                                  _vm._s(
                                    _vm.$ct("peppol-default-bank-is-not-okay")
                                  )
                                ),
                              ]),
                              _c("div", [
                                _c(
                                  "a",
                                  {
                                    staticClass: "link",
                                    on: {
                                      click: function ($event) {
                                        $event.preventDefault()
                                        return _vm.editBanks()
                                      },
                                    },
                                  },
                                  [
                                    _vm._v(
                                      _vm._s(
                                        _vm.$ct(
                                          "click-here-to-complete-bank-setup"
                                        )
                                      )
                                    ),
                                  ]
                                ),
                              ]),
                            ]),
                          ],
                          1
                        ),
                      ],
                      1
                    )
                  : _vm._e(),
                _c(
                  "w-row",
                  [
                    _c(
                      "w-col",
                      { attrs: { xs: "12" } },
                      [
                        _c(
                          "w-row",
                          { attrs: { "no-margin": "", center: "" } },
                          [
                            _vm.checkResponse == null
                              ? _c("w-progress-circular", {
                                  staticClass: "mr",
                                  attrs: { small: "" },
                                })
                              : _vm.checkResponse.Registered
                              ? _c("w-fa", {
                                  staticClass: "mr",
                                  attrs: { icon: "check" },
                                })
                              : _c("w-fa", {
                                  staticClass: "mr",
                                  attrs: { icon: "times" },
                                }),
                            _vm.sale.Contact
                              ? [
                                  _vm._v(
                                    _vm._s(_vm.sale.Contact.getDisplayName())
                                  ),
                                ]
                              : _vm._e(),
                          ],
                          2
                        ),
                      ],
                      1
                    ),
                  ],
                  1
                ),
                _c(
                  "w-row",
                  [
                    _vm.endpointItems.length > 1
                      ? _c(
                          "w-col",
                          { attrs: { xs: "12" } },
                          [
                            _c("w-select", {
                              attrs: {
                                fancy: "",
                                label: _vm.$ct("endpoint"),
                                items: _vm.endpointItems,
                              },
                              model: {
                                value: _vm.selectedEndpointID,
                                callback: function ($$v) {
                                  _vm.selectedEndpointID = $$v
                                },
                                expression: "selectedEndpointID",
                              },
                            }),
                          ],
                          1
                        )
                      : _vm._e(),
                    _c(
                      "w-col",
                      { attrs: { xs: "12" } },
                      [
                        _c("w-input", {
                          attrs: { fancy: "", label: _vm.$ct("po") },
                          model: {
                            value: _vm.po,
                            callback: function ($$v) {
                              _vm.po = $$v
                            },
                            expression: "po",
                          },
                        }),
                      ],
                      1
                    ),
                    _c(
                      "w-col",
                      { attrs: { xs: "12" } },
                      [
                        _c("w-input", {
                          attrs: { fancy: "", label: _vm.$ct("department") },
                          model: {
                            value: _vm.department,
                            callback: function ($$v) {
                              _vm.department = $$v
                            },
                            expression: "department",
                          },
                        }),
                      ],
                      1
                    ),
                    _c(
                      "w-col",
                      { attrs: { xs: "12" } },
                      [
                        _c("w-select", {
                          attrs: {
                            fancy: "",
                            label: _vm.$ct("documentType"),
                            items: _vm.documentTypes,
                          },
                          model: {
                            value: _vm.documentType,
                            callback: function ($$v) {
                              _vm.documentType = $$v
                            },
                            expression: "documentType",
                          },
                        }),
                      ],
                      1
                    ),
                  ],
                  1
                ),
                _c(
                  "w-row",
                  [
                    _c(
                      "w-col",
                      { attrs: { xs: "12" } },
                      [
                        _c(
                          "app-file-upload",
                          {
                            attrs: {
                              "max-size": _vm.maxFileSize,
                              multiple: "",
                            },
                            on: {
                              input: function ($event) {
                                return _vm.onFileInput($event)
                              },
                            },
                          },
                          [
                            _c("w-fa", { attrs: { icon: "file" } }),
                            _vm._v(
                              " " + _vm._s(_vm.$ct("upload-attachment")) + " "
                            ),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                  ],
                  1
                ),
                _c(
                  "w-row",
                  _vm._l(_vm.files, function (item, i) {
                    return _c("w-col", { key: i, attrs: { xs: "12" } }, [
                      _c(
                        "div",
                        { staticClass: "file" },
                        [
                          _vm._v(" " + _vm._s(item.name) + " "),
                          _c("w-spacer"),
                          _c(
                            "w-button",
                            {
                              directives: [
                                {
                                  name: "tooltip",
                                  rawName: "v-tooltip",
                                  value: _vm.$ct("remove-attachment"),
                                  expression: "$ct('remove-attachment')",
                                },
                              ],
                              staticClass: "danger",
                              attrs: { flat: "" },
                              on: {
                                click: function ($event) {
                                  return _vm.removeFile(i)
                                },
                              },
                            },
                            [_c("w-fa", { attrs: { icon: "trash" } })],
                            1
                          ),
                        ],
                        1
                      ),
                    ])
                  }),
                  1
                ),
              ],
              1
            ),
            _c(
              "w-card-actions",
              [
                _c(
                  "w-button",
                  {
                    staticClass: "cancel",
                    attrs: { icon: "ban" },
                    on: {
                      click: function ($event) {
                        return _vm.close()
                      },
                    },
                  },
                  [_vm._v(" " + _vm._s(_vm.$t("common.cancel")) + " ")]
                ),
                _c("w-spacer"),
                _c(
                  "w-button",
                  {
                    attrs: {
                      disabled: !_vm.valid || _vm.sending,
                      icon: "envelope",
                    },
                    on: {
                      click: function ($event) {
                        return _vm.send()
                      },
                    },
                  },
                  [_vm._v(" " + _vm._s(_vm.$t("common.send")) + " ")]
                ),
              ],
              1
            ),
          ]
        : _c(
            "w-card-content",
            [
              _c("app-missing-module", {
                attrs: { "module-id": _vm.moduleId },
              }),
            ],
            1
          ),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }